export default __webpack_public_path__ + "static/m-from-abroad-one-554a05853f44e4b87beb46a6e9f92114.jpg";